module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g4vJK"))).then(() => parcelRequire('ikE14'));